import { render, staticRenderFns } from "./UsuarioFormArquivo.vue?vue&type=template&id=9fb4bd22&scoped=true"
import script from "./UsuarioFormArquivo.vue?vue&type=script&lang=js"
export * from "./UsuarioFormArquivo.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFormArquivo.vue?vue&type=style&index=0&id=9fb4bd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb4bd22",
  null
  
)

export default component.exports